import { PropsWithChildren, createContext, useContext } from 'react';

const commentZoneContext = createContext<string>('');

type ZoneData = { [key: string]: string };

export const CommentZoneProvider = ({
  zone,
  children,
}: PropsWithChildren<{ zone: string }>) => {
  return (
    <commentZoneContext.Provider value={zone}>
      {children}
    </commentZoneContext.Provider>
  );
};

export interface CommentZoneContextProps
  extends PropsWithChildren<{
    // Zone ID
    zone: string;

    // Auxiliary data for the zone
    data?: ZoneData;
  }> {}

export const CommentZoneContext = (props: CommentZoneContextProps) => {
  const { zone, data, children } = props;
  const context = useContext(commentZoneContext);
  const qualifiedZone = makeZone(context, zone, data);

  return (
    <CommentZoneProvider zone={qualifiedZone}>{children}</CommentZoneProvider>
  );
};

export function useCommentZone(): string {
  return useContext(commentZoneContext);
}

// Helper function to create a zone ID
// @internal
function makeZone(parent: string, id: string, data?: ZoneData) {
  const fullId = data
    ? `${id}[${Object.entries(data)
        .map(([k, v]) => `${k}:${v}`)
        .join(',')}]`
    : id;
  const concatId = parent.length > 0 ? `${parent}/${fullId}` : fullId;
  return concatId;
}

export function useZone(zone: string, data?: ZoneData) {
  const parent = useCommentZone();
  return makeZone(parent, zone, data);
}
